import { Button, Form, Modal, TextArea } from '@mairistem/composants';
import { Combobox } from '@mairistem/finances-utils';
import React from 'react';
import DemandeStatusEnum from '../../enums/demandeStatusEnum';

interface StatutModalProps {
	onClose: () => void;
	onValidate: (
		statut: string,
		messagePrive: string,
		messagePublic: string,
	) => void;
	isLoading: boolean;
}

const RAZ_STATUS = 'RazStatus';

const statutOptions = [
	{
		key: DemandeStatusEnum.ABANDON,
		text: DemandeStatusEnum.ABANDON,
		value: DemandeStatusEnum.ABANDON,
	},
	{
		key: DemandeStatusEnum.TRAITEE,
		text: DemandeStatusEnum.TRAITEE,
		value: DemandeStatusEnum.TRAITEE,
	},
	{ key: RAZ_STATUS, text: 'Remise à zéro du statut', value: RAZ_STATUS },
];

const StatutModal = ({ onValidate, onClose, isLoading }: StatutModalProps) => {
	const [statut, setStatut] = React.useState<string>(DemandeStatusEnum.TRAITEE);
	const [messagePrive, setMessagePrive] = React.useState<string>('');
	const [messagePublic, setMessagePublic] = React.useState<string>('');

	return (
		<Modal onClose={onClose} size="small" open>
			<Modal.Header>
				Modification du statut de la demande de compte
			</Modal.Header>
			<Modal.Content>
				<Form>
					<Form.Field
						control={Combobox}
						label="Veuillez sélectionner le nouveau statut :"
						// @ts-expect-error
						fluid
						selection
						value={statut}
						options={statutOptions}
						onChange={(
							_e: React.SyntheticEvent<HTMLElement>,
							{ value }: { value: string },
						) => setStatut(value)}
					/>
					<Form.Field
						// @ts-expect-error
						control={TextArea}
						label="Message public :"
						fluid
						value={messagePublic}
						onChange={(
							_e: React.SyntheticEvent<HTMLElement>,
							{ value }: { value: string },
						) => setMessagePublic(value)}
					/>
					<Form.Field
						// @ts-expect-error
						control={TextArea}
						label="Message Administrateur:"
						fluid
						value={messagePrive}
						onChange={(
							_e: React.SyntheticEvent<HTMLElement>,
							{ value }: { value: string },
						) => setMessagePrive(value)}
					/>
				</Form>
			</Modal.Content>
			<Modal.Actions>
				<Button color="black" onClick={onClose}>
					Annuler
				</Button>
				<Button
					icon="checkmark"
					onClick={() => onValidate(statut, messagePrive, messagePublic)}
					primary
					loading={isLoading}
				>
					Modifier le statut
				</Button>
			</Modal.Actions>
		</Modal>
	);
};

export default StatutModal;
